import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useClientContext } from '@/context/client'
import WhatsAppInput from '@/components/form/input/whatsApp-mask-input'
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form'
import { isValidPersonName } from '@/utils/format'

const contadorSchema = z.object({
  name: z.string().min(1, 'Nome é obrigatório').refine(isValidPersonName, 'Nome não pode conter números'),
  whatsapp: z.string().min(1, 'WhatsApp é obrigatório'),
  email: z.string().email('E-mail inválido')
})

type ContadorFormValues = z.infer<typeof contadorSchema>

export function ContadorForm({ onContinue }: { onContinue: () => void }) {
  const { setContadorData, podeCriarCliente, setMostrarCampos } = useClientContext()

  const form = useForm<ContadorFormValues>({
    resolver: zodResolver(contadorSchema),
    defaultValues: {
      name: '',
      whatsapp: '',
      email: ''
    }
  })

  const onSubmit = (data: ContadorFormValues) => {
    setContadorData(data)
    setMostrarCampos(true)
    onContinue()
  }

  return (
    <div>
      <div className="py-2  mb-2 border-b">
        <h2 className="font-bold text-base">Dados do Contador</h2>
      </div>
      <div>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nome do Contador</FormLabel>
                  <FormControl>
                    <Input placeholder="Digite o nome" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="whatsapp"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>WhatsApp</FormLabel>
                  <FormControl>
                    <WhatsAppInput {...field} value={field.value || ''} onChange={field.onChange} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>E-mail</FormLabel>
                  <FormControl>
                    <Input type="email" placeholder="Digite o e-mail" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <Button
              type="submit"
              className="mt-2 w-full bg-primary hover:bg-primary-hover text-primary-foreground"
              disabled={!podeCriarCliente}
            >
              Continuar
            </Button>
          </form>
        </Form>
      </div>
    </div>
  )
}
